import { useCallback } from "react";
import { SearchViewMode } from "../use-view-mode/types";
import { MapViewRightAlleyState, RightAlleyState } from "./types";
import { useMapViewRightAlleyState } from "./use-map-view-right-alley-state";
import { useRightAlleyState } from "./use-right-alley-state";
var getFilterAlleyTab = function (rightAlleyState) {
    switch (rightAlleyState) {
        case RightAlleyState.Filters:
            return RightAlleyState.Filters;
        case RightAlleyState.GeoFilters:
            return RightAlleyState.GeoFilters;
    }
};
export var useRightAlleyStates = function (viewMode, searchMode, initialState, initialMapViewState) {
    if (initialState === void 0) { initialState = RightAlleyState.None; }
    if (initialMapViewState === void 0) { initialMapViewState = MapViewRightAlleyState.Placards; }
    var rightAlleyState = useRightAlleyState(viewMode, searchMode, initialState);
    var mapViewRightAlleyState = useMapViewRightAlleyState(viewMode, searchMode, initialMapViewState);
    var setMapViewRightAlleyState = mapViewRightAlleyState.setRightAlleyState;
    var setRightAlleyState = rightAlleyState.setRightAlleyState;
    var filterAlleyTab;
    switch (viewMode) {
        case SearchViewMode.MapView:
            filterAlleyTab = getFilterAlleyTab(mapViewRightAlleyState.rightAlleyState);
            break;
        case SearchViewMode.ListView:
        case SearchViewMode.GalleryView:
            filterAlleyTab = getFilterAlleyTab(rightAlleyState.rightAlleyState);
            break;
    }
    var setFilterAlleyTab = useCallback(function (tab) {
        switch (viewMode) {
            case SearchViewMode.MapView:
                setMapViewRightAlleyState(tab);
                break;
            case SearchViewMode.ListView:
            case SearchViewMode.GalleryView:
                setRightAlleyState(tab);
                break;
        }
    }, [setRightAlleyState, setMapViewRightAlleyState, viewMode]);
    var filtersShown = filterAlleyTab != null;
    var hideFilters = useCallback(function () {
        if (viewMode === SearchViewMode.MapView) {
            setMapViewRightAlleyState(MapViewRightAlleyState.Placards);
        }
        else {
            setRightAlleyState(RightAlleyState.None);
        }
    }, [setRightAlleyState, setMapViewRightAlleyState, viewMode]);
    var toggleFilters = useCallback(function () {
        if (viewMode === SearchViewMode.MapView) {
            setMapViewRightAlleyState(filtersShown ? MapViewRightAlleyState.Placards : MapViewRightAlleyState.Filters);
        }
        else if (viewMode === SearchViewMode.ListView) {
            setRightAlleyState(filtersShown ? RightAlleyState.None : RightAlleyState.Filters);
        }
        else if (viewMode === SearchViewMode.GalleryView) {
            setRightAlleyState(filtersShown ? RightAlleyState.None : RightAlleyState.Filters);
        }
    }, [setRightAlleyState, setMapViewRightAlleyState, filtersShown, viewMode]);
    return {
        rightAlleyState: rightAlleyState,
        mapViewRightAlleyState: mapViewRightAlleyState,
        filtersShown: filtersShown,
        filterAlleyTab: filterAlleyTab,
        setFilterAlleyTab: setFilterAlleyTab,
        hideFilters: hideFilters,
        toggleFilters: toggleFilters,
        setRightAlleyState: setRightAlleyState,
        setMapViewRightAlleyState: setMapViewRightAlleyState,
    };
};
//# sourceMappingURL=use-right-alley-states.js.map